import React from 'react';

/* Tela exibida quando o usuário não tem permissão para acessar a funcionalidade solicitada */
const SemPermissao = () => {
  return (
    <div style={{ padding: 24 }}>
      <h2>Acesso não autorizado</h2>
      <p>Você não possui permissão para acessar esta funcionalidade.</p>
    </div>
  );
};

export default SemPermissao;